import { usePaginationCore } from './usePaginationCore';
import { createScroll, createDataMerge } from './plugins';
import { ref } from 'vue';

/**
 * 滚动加载 - 简化版插件化组合实现
 * 与 usePaginationMobile 逻辑完全一致，用于新的滚动加载数据场景
 * @param {Object} options 配置选项
 * @param {Function} options.bindChange 数据变化时的回调函数
 * @param {number} options.defaultSize 默认页大小，默认为20
 * @returns {Object} 滚动加载相关的响应式数据和方法
 */
export const useScrollLoad = (options = {}) => {
	const { bindChange, defaultSize = 20 } = options;

	const maxElTableHeight = ref('587px');

	// 创建核心分页实例，默认页大小为20
	const pagination = usePaginationCore({
		defaultSize,
		bindChange
	});
	// 插件注册：数据拼装
	pagination.use(createDataMerge());
	// 插件注册：滚动加载
	pagination.use(createScroll());

	const scroll = pagination.pluginContext.scroll;
	const dataMerge = pagination.pluginContext.dataMerge;

	// 返回组合后的API
	return {
		// 核心分页状态和方法
		...pagination,

		// 数据管理方法
		finalData: dataMerge.finalData,
		resetFinalData: dataMerge.resetFinalData,
		appendFinalData: dataMerge.appendFinalData,
		setData: dataMerge.setData, // 快捷赋值接口

		// 滚动加载状态和方法
		hasMoreData: scroll?.hasMoreData,
		onPullDown: scroll?.onPullDown,
		onPullUp: scroll?.onPullUp,

		maxElTableHeight
	};
};
